import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import ImageR from '../assets/img/Icons/Icons/image.png'

import ImageQ from '../assets/img/Icons/Icons/imageQ.png'
import ImageC from '../assets/img/Icons/Icons/imagechat.png'
import Barside from '../assets/img/Icons/Icons/Icon-17.png'
import Footer from '../pages/footer'
const ContactUs = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                        <div className="col-sm-1-my17 ">
                            <Sidebar/>
                        </div>
                        <div className="col-sm-11-my17 text-center ">

                            <h5 className=" signin1-h1-top  mb-0">Contact US</h5>
                        </div>

                    </div>

                    <div className="row page17-p">
                        <div className="col-sm-12 py-2">
                            <hr className="mt-2" />

                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="btn-light  p-3 contact-card  mt-2 ">
                                        <p className="mb-0"><span><img src={ImageR} alt="" className="Contact-cardimg-sm" /></span><span className="contact-card-mid-info">Payments</span><i className="fa fa-angle-right float-right" aria-hidden="true"></i></p>
                                    </div>

                                    <div className="btn-light  p-3 contact-card  mt-2 ">
                                        <p className="mb-0"><span><img src={ImageR} alt="" className="Contact-cardimg-sm" /></span><span className="contact-card-mid-info">Referrals</span><i className="fa fa-angle-right float-right" aria-hidden="true"></i></p>
                                    </div>
                                    <div className="btn-light  p-3 contact-card  mt-2 ">
                                        <p className="mb-0"><span><img src={ImageQ} alt="" className="Contact-cardimg-sm" /></span><span className="contact-card-mid-info">Subscription</span><i className="fa fa-angle-right float-right" aria-hidden="true"></i></p>
                                    </div>
                                    <div className="btn-light  p-3 contact-card  mt-2 ">
                                        <p className="mb-0"><span><img src={ImageC} alt="" className="Contact-cardimg-big-sm" /></span><span className="contact-card-mid-info">Chat with us</span><i className="fa fa-angle-right float-right" aria-hidden="true"></i></p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default ContactUs;

